import axios from 'axios';

export default {
  fetchCategories(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/panorama/reference-data/categories")
      .then(results=>{
        return results.data;
      })
  },
  fetchSubCategories(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/panorama/reference-data/sub-categories")
      .then(results=>{
        return results.data;
      })
  },
  fetchSweetness(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/panorama/reference-data/sweetness")
      .then(results=>{
        return results.data;
      })
  },
}
